<script>
  import { onMount } from "svelte";

  // TODO: switch to https://github.com/kaimallea/isMobile/
  function isTouchEnabled() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  function isIos() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  let instagramLink = "https://www.instagram.com/countrycruel/";
  let facebookLink = "https://www.facebook.com/CountryCruel";
  let spotifyLink = "https://open.spotify.com/artist/08ZCGct1NNWBiuFGNavuH4";

  // Spotify handles its own mobile app deep linking
  onMount(async () => {
    const hasTouch = isTouchEnabled();
    const width =
      window.screen.width < window.outerWidth
        ? window.screen.width
        : window.outerWidth;

    // Probably mobile ios
    if (hasTouch && width <= 768 && isIos()) {
      instagramLink = "instagram://user?username=countrycruel";
      // facebookLink = "fb://page/?id=103893492205294";
    }
    // Probably mobile android
    else if (hasTouch && width <= 768) {
      instagramLink =
        "intent://instagram.com/countrycruel#Intent;scheme=https;package=com.instagram.android;end";
      // facebookLink =
      // "intent://page/103893492205294?referrer=app_link#Intent;package=com.facebook.katana;scheme=fb;end";
    }
  });
</script>

<footer>
  <span>
    <a
      class="social-media-link"
      href={facebookLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fab fa-facebook fa-3x" title="Facebook icon" />
    </a>
    <a
      class="social-media-link"
      href={instagramLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fab fa-instagram fa-3x" title="Instagram icon" />
    </a>
    <a
      class="social-media-link"
      href={spotifyLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fab fa-spotify fa-3x" title="Spotify icon" />
    </a>
  </span>
  <span class="copyright">
    <a href="https://karstenrabe.dev" target="_blank" rel="noopener noreferrer"
      >Copyright &copy; Karsten Rabe 2022</a
    >
  </span>
</footer>

<style>
  footer {
    margin-top: 1.5rem;
    height: 4rem;
  }
  a.social-media-link {
    color: #4a422f;
    padding: 2rem 1rem;
  }
  i {
    width: 3rem;
    height: 3rem;
    transition: transform 0.2s;
  }
  i:hover {
    -webkit-transform: scale(1.25);
    -moz-transform: scale(1.25);
    -ms-transform: scale(1.25);
    -o-transform: scale(1.25);
    transform: scale(1.25);
  }
  a:hover {
    color: #3b3425;
  }
  span {
    display: inline-block;
    width: 100%;
  }
  span.copyright {
    margin: 1rem 0;
    padding: 1rem 0;
  }
  span.copyright a:hover {
    color: #4a422f;
  }
  @media only screen and (min-width: 640px) {
    a.social-media-link {
      padding: 2rem 3rem;
    }
  }
</style>
